import listEmbeddableMixin from "@/mixins/embeddable/resource/listEmbeddableMixin";
import ProductionOrderEmbeddable from "@/views/modules/production/ProductionOrder/embeddable/ProductionOrderEmbeddable";


export default {
    components:{ProductionOrderEmbeddable},
    mixins: [listEmbeddableMixin],
    data() {
        return {
            path: "production/order", //Override somente de front-end, por tanto irá utilizar o mesmo path que o original da página 56
        }

    },
    async mounted() {

        /*Declarar todos os campos no padrão que podem ser utilizados*/

        const formDefault = {
            default: "", //NÃO ESQUECER DOS CAMPOS PADROES DE BUSCA COMO DEFAULT E STATUS (caso existir)
            deadline: "",
            issueDate: "",
            operationStatusId: 0,
            stepCurrentProcessFlowStepId:0,
            typeNonConformanceId:0,
            expeditionNumber:0,
            productId:0,
            lotId:0,
            materialId:0,
            groupProductId:0,
            processFlowId:0,
            model:"",
            statusBatch: 0,
            hasStock:null,
            reprocessed:null,
        }

        this.form = Object.assign({}, formDefault,this.form);
    },
    methods:{

    }
}